import React, { Component } from "react";
import "./styles/Wall.css";
import { ListSkeleton } from "../components/Skeleton";
import WallLeft from "../components/WallLeft";
import WallRight from "../components/WallRight";
import WallComments from "../components/WallComments";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/wallActions";
import { connect } from "react-redux";

class Wall extends Component {
  componentDidMount() {
    if (!this.props.wallLoaded) {
      this.fetchCommentList();
    }
  }

  fetchCommentList = async () => {
    try {
      await this.props
        .LoadWall(this.props.token, {
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <div className="wall-page">
        <div className="wall-page-inner">
          <div className="row">
            <aside className="col-lg-3 d-none d-lg-block wall-page-side">
              <WallLeft />
            </aside>
            <main className="col-lg-6 wall-page-main">
              {!this.props.wallLoaded ? (
                <ListSkeleton count={4} />
              ) : (
                <WallComments />
              )}
            </main>
            <aside className="col-lg-3 d-none d-lg-block wall-page-side">
              <WallRight />
            </aside>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    wallList: reducer.wall.list,
    wallLoaded: reducer.wall.loaded,
    error: reducer.wall.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadWall: (token, params) =>
    dispatch(actions.loadList({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wall);
